import {
  FASTLY_FIT,
  resizeFastlyImage,
  resizeMascotImage
} from '@maxpreps/shared/functions/utils/resizeImage';
import styled from 'styled-components';
import ListItem, { getFallbackColor, IconType } from './ListItem';

const StyledFavoritesList = styled.ul`
  padding: 0;
  margin: 0;
`;

const ICON_SIZE = 40;
const getFavorites = (favorites: any[], type: IconType) =>
  favorites.map(f => {
    let { photoUrl, header } = f;

    if (type === IconType.Team) {
      photoUrl = resizeMascotImage(photoUrl, null, ICON_SIZE, ICON_SIZE);
    } else if (type == IconType.Career) {
      photoUrl = resizeFastlyImage(photoUrl, {
        fit: FASTLY_FIT.Cover,
        width: ICON_SIZE,
        crop: '1:1,smart'
      });
    }

    return (
      <ListItem
        type={type}
        iconName={header}
        iconUrl={photoUrl}
        iconSize={ICON_SIZE}
        key={`${type}-${f.link}`}
        header={f.header}
        subheader={f.subHeader}
        href={f.link}
        fallbackColor={getFallbackColor(
          f.schoolColor1,
          f.schoolColor2,
          f.schoolColor3
        )}
      />
    );
  });

const FavoritesList: React.FC<{ teams: any; careers: any }> = ({
  teams,
  careers
}) => (
  <StyledFavoritesList>
    {teams && getFavorites(teams, IconType.Team)}
    {careers && getFavorites(careers, IconType.Career)}
  </StyledFavoritesList>
);

export default FavoritesList;
